import manifest from '../assets/question-cutouts/manifest.json';
import money1 from '../assets/tutor-icons/final/money-tier-1.jpeg';
import money2 from '../assets/tutor-icons/final/money-tier-2.webp';
import money3 from '../assets/tutor-icons/final/money-tier-3.webp';
import money4 from '../assets/tutor-icons/final/money-tier-4-diamond.webp';
import oak from '../assets/tutor-icons/final/oak-or-toast.png';
import vanilla from '../assets/tutor-icons/final/oak-spice-and-vanilla.png';
import oakToastIllustration from '../assets/illustrations/oak-toast.webp';
import oakSpiceIllustration from '../assets/illustrations/oak-spice-vanilla.webp';
import wineYoung from '../assets/illustrations/wine-young.webp';
import wineAged from '../assets/illustrations/wine-aged.webp';
import wineDeveloping from '../assets/illustrations/wine-developing.webp';
import wineMature from '../assets/illustrations/wine-mature.webp';

export const QUESTION_ICON_BACKGROUND = '#FDCF63';
const BASE = 'https://cmrrsjwbbeurszecszhg.supabase.co/storage/v1/object/public/questionicons/';
const assets = import.meta.glob('../assets/question-cutouts/*.webp', {
  eager: true, query: '?url', import: 'default',
});
const localKeys = new Map([
  [money1, 'money-tier-1.jpeg'], [money2, 'money-tier-2.webp'],
  [money3, 'money-tier-3.webp'], [money4, 'money-tier-4-diamond.webp'],
  [oak, 'oak-or-toast.png'], [vanilla, 'oak-spice-and-vanilla.png'],
]);
const replacements = {
  'questionicons/young.jpeg': wineYoung,
  'questionicons/aged.jpeg': wineAged,
  'questionicons/developing.jpeg': wineDeveloping,
  'questionicons/mature.jpeg': wineMature,
  'questionicons/Oak or toast.jpeg': oakToastIllustration,
  'questionicons/Oak spice and vanilla.jpeg': oakSpiceIllustration,
  'tutor/oak-or-toast.png': oakToastIllustration,
  'tutor/oak-spice-and-vanilla.png': oakSpiceIllustration,
};

export function questionIllustrationSource(src) {
  if (typeof src !== 'string') return src;
  let key;
  if (localKeys.has(src)) key = 'tutor/' + localKeys.get(src);
  else if (src.startsWith(BASE)) {
    try {
      key = 'questionicons/' + decodeURIComponent(src.slice(BASE.length).split(/[?#]/)[0]).replace(/^\/+/, '');
    } catch { return src; }
  }
  // Exact names matter: Orange.png is fruit; orange.jpeg is a wine swatch.
  if (replacements[key]) return replacements[key];
  const entry = manifest[key];
  return (entry && assets['../assets/question-cutouts/' + entry.file]) || src;
}
